"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationForm = void 0;
const UiElements_1 = require("../../ui/UiElements");
const annotationTextEditor_1 = require("../../../text-editor/annotationTextEditor");
class AnnotationForm {
    constructor(annotationService, apiService) {
        this.annotationService = annotationService;
        this.apiService = apiService;
        this._manualId = undefined;
        this._name = "";
        this._orderNumber = null;
        this._isVisible = false;
        this.orderNumberEl = this.createOrderInput();
        this.nameEl = this.createNameInput();
        this.formEl = this.create();
    }
    get manualId() { return this._manualId; }
    set manualId(manualId) { this._manualId = manualId; }
    get orderNumber() { return this._orderNumber; }
    set orderNumber(orderNumber) {
        this._orderNumber = orderNumber;
        this.orderNumberEl.domEl.value = orderNumber;
    }
    get name() { return this._name; }
    set name(name) {
        this._name = name;
        this.nameEl.domEl.value = name;
    }
    get isVisible() { return this._isVisible; }
    set isVisible(isVisible) {
        this._isVisible = isVisible;
        this.formEl.domEl.style.display = isVisible ? 'block' : 'none';
    }
    /**
     * Content form
     */
    create() {
        const annotationEditor = document.getElementById('annotationEditor');
        if (!annotationEditor) {
            throw new Error("Undefined element annotationEditor");
        }
        const form = this.createForm();
        annotationEditor.appendChild(form.domEl);
        this.annotationTextEditor = new annotationTextEditor_1.AnnotationTextEditor(this.annotationService, this.apiService, form);
        return form;
    }
    /**
     * Form
     */
    createForm() {
        return new UiElements_1.FormEl()
            .setClass('annotationForm')
            .setEvent('change', (event) => {
            event.preventDefault();
        });
    }
    /**
     * Order number input
     */
    createOrderInput() {
        return new UiElements_1.InputEl(this._orderNumber !== null ? this._orderNumber.toString() : '')
            .setId('orderInput')
            .setStyle({ 'display': 'block' })
            .addAttribute('placeholder', '0-99');
    }
    /**
     * Name input
     */
    createNameInput() {
        return new UiElements_1.InputEl("Title")
            .setClass("annotationTitle");
    }
}
exports.AnnotationForm = AnnotationForm;
